@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3>{{ pageTitle }}</h3>
</div>

<div class="request-control" #goUp>
  <div class="right-side">
    @if (filterData) {
      <app-filter
        [filterData]="filterData"
        [filterDataInit]="filterDataInit"
        [filterPage]="filterPage"
        (formValus)="filterFormValues($event)"
      >
      </app-filter>
    }
    <quick-search
      [placeholder]="'البحث برقم التعريف، الاسم، البريد الإلكتروني...'"
      (searchResults)="quickSearch($event)"
    ></quick-search>
  </div>
</div>

<div class="saved-filters">
  <saved-filters></saved-filters>
</div>

<div class="request-table">
  @if (servicesRequestsList && servicesRequestsList.length == 0 && !spinner) {
    <app-empty-state></app-empty-state>
  } @else {
    <div class="table-responsive">
      <table
        id="services-requests-table"
        class="table table-striped"
        aria-label="Services Requests Table"
      >
        <thead>
          <tr>
            <th class="width-10">الأسم</th>
            <th class="width-10">الرقم التعريفي</th>
            <th class="width-10">الخدمة</th>
            <th class="width-15">البريد الالكتروني</th>
            <th class="width-10">تاريخ التقديم</th>
            <th class="width-10">تاريخ الموافقة</th>
            <th class="width-10">تاريخ آخر تعديل</th>
            <th class="width-10">حالة الطلب</th>
            <th class="width-15">تنفيذ الأمر</th>
          </tr>
        </thead>
        <tbody>
          @for (
            request of servicesRequestsList | paginate: config;
            track request.id;
            let i = $index
          ) {
            <tr
              (click)="openDetails(request.application_id)"
              class="clickable-row"
            >
              <td class="width-10">{{ request.expert.full_name }}</td>
              <td class="width-10">
                <a
                  class="link-id"
                  (click)="goInspector($event, request.expert.id)"
                >
                  {{ request.expert.internal_id }}
                </a>
              </td>

              <td class="width-10">{{ request.classification.name }}</td>
              <td class="width-15">{{ request.expert.email }}</td>
              <td class="width-10">
                {{ formatDate(request.created_at) ?? "-" }}
              </td>
              <td class="width-10">
                {{ formatDate(request.approved_at) ?? "-" }}
              </td>
              <td class="width-10">
                {{ formatDate(request.updated_at) ?? "-" }}
              </td>
              <td class="width-10">
                <span [ngClass]="getStatusClass(request.status)">
                  {{ applicationStatusLabel[request.status] || "-" }}
                </span>
              </td>
              <td class="width-15">
                <button
                  class="btn btn-details"
                  (click)="openDetails(request.id); $event.stopPropagation()"
                >
                  التفاصيل
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

@if (servicesRequestsList && servicesRequestsList.length > 0) {
  <ayen-pagination
    (pageData)="pageChanged($event)"
    (pageSize)="pageSizeChanged($event)"
    [totalCount]="config.totalItems"
    [itemsPerPage]="config.itemsPerPage"
    (pageChange)="changeToSpecific($event)"
    [currentPage]="config.currentPage"
  >
  </ayen-pagination>
}
